var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"columns",class:['columns-' + _vm.curRow.name],style:(_vm.animStyle)},[_c('div',{staticClass:"column"}),_c('div',{staticClass:"column"}),_c('div',{staticClass:"column"})])])}
var staticRenderFns = []

export { render, staticRenderFns }